import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import useGetTeamMembers from '../../../hooks/staticQueries/useGetTeamMembers';
import Button from '../../../components/button/Button';
import ChevronRound from '../../../assets/icons/chevron_round';

import './careTeamSection.scss';

export default function CareTeamSection(props) {
  const { pretitle, title, subtitle } = props;

  const { director, members } = useGetTeamMembers();

  const allMembers = [director, ...members];
  const displayedMembers = allMembers.filter((m) => m.profilePictureBackground);

  function getMemberFullFunction(memberFunction) {
    switch (memberFunction) {
      case 'md':
        return 'Doctor of Medicine';
      case 'np':
        return 'Nurse Practitioner';
      default:
        return '';
    }
  }

  function getDotsCount() {
    const cardsContainer = document.getElementById('members-cards-container');
    if (!cardsContainer) { return 0; }

    const firstCard = cardsContainer.firstElementChild;
    const lastCard = cardsContainer.lastElementChild;
    const cardsContainerGap = parseInt(getComputedStyle(cardsContainer).gap, 10);
    const cardsContainerWidth = cardsContainer.offsetWidth - (firstCard.offsetLeft * 2);

    const displayedCardsCount = Math.floor(
      (cardsContainerWidth - lastCard.offsetWidth) / (firstCard.offsetWidth + cardsContainerGap),
    );

    return (displayedMembers.length) - displayedCardsCount;
  }

  const [dotsCount, setDotsCount] = useState(0);
  const [iMember, setIMember] = useState(0);

  function navigateToMember(index) {
    const cardsContainer = document.getElementById('members-cards-container');
    const firstCard = cardsContainer.firstElementChild;
    const cardsContainerGap = parseInt(getComputedStyle(cardsContainer).gap, 10);

    cardsContainer.scrollTo({
      left: Math.round((firstCard.offsetWidth + cardsContainerGap) * index),
      behavior: 'smooth',
    });

    setIMember(index);
  }

  function navigateMembers(next = false) {
    const cardsContainer = document.getElementById('members-cards-container');
    const firstCard = cardsContainer.firstElementChild;
    const cardsContainerGap = parseInt(getComputedStyle(cardsContainer).gap, 10);

    let newIMember = iMember;

    if (next && iMember < dotsCount) {
      newIMember = iMember + 1;
    } else if (!next && iMember > 0) {
      newIMember = iMember - 1;
    }

    cardsContainer.scrollTo({
      left: Math.round((firstCard.offsetWidth + cardsContainerGap) * newIMember),
      behavior: 'smooth',
    });

    setIMember(newIMember);
  }

  useEffect(() => {
    setDotsCount(getDotsCount());

    window.addEventListener('resize', () => {
      const newDotsCount = getDotsCount();
      setDotsCount(newDotsCount);

      if (iMember >= newDotsCount + 1) {
        setIMember(newDotsCount);
      }
    });
  }, []);

  return (
    <section id="care-team" className="meet_care_team">
      <div className="title-container">
        <p className="overline salmon">{pretitle}</p>
        <h2>{parse(title)}</h2>
        <h6>{subtitle}</h6>
      </div>

      <div className="content-container">
        <div className="navigation">
          <ChevronRound
            disabled={iMember === 0}
            onClick={() => navigateMembers()}
          />
          <ChevronRound
            right
            disabled={iMember === dotsCount}
            onClick={() => navigateMembers(true)}
          />
        </div>
        <div id="members-cards-container" className="cards-container">
          {displayedMembers.filter((member) => member.profilePictureBackground).map((member) => (
            <div
              key={member.name}
              className="card"
              style={{ backgroundImage: `url(${member.profilePictureBackground})` }}
            >
              <div className="overlay" />
              <h5>{ `${member.name}, ${member.function.toUpperCase()}` }</h5>
              <p>{ `${getMemberFullFunction(member.function)} ${member.isLead ? 'Lead' : ''}` }</p>
            </div>
          ))}

          <div className="card view-more">
            <a href="/aboutUs">View more</a>
          </div>
        </div>

        <div className="dots-container">
          {Array.from({ length: dotsCount + 1 }).map((_, i) => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <div
              type="button"
              className={`dot ${i === iMember ? 'active' : ''}`}
              onClick={() => navigateToMember(i)}
            />
          ))}
        </div>
      </div>

      <Button
        text="Meet care team"
        displayArrow
        dataAttr="CTA_clicked_care-team"
        link="/aboutUs"
        className="blue"
        onClick={() => {
          if (window.posthog) window.posthog.capture('cta_enroll_now', { section: 'meet_care_team' });
        }}
      />
    </section>
  );
}

CareTeamSection.propTypes = {
  pretitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};
